import bbox from '@turf/bbox';
import { GAME_MODE, SCORE_MODE } from '../../constants';
import i18n from '../../lang';
import router from '../../router';
import { getMaxDistanceBbox } from '../../utils';
import * as MutationTypes from '../mutation-types';
import { consumePlayQuota, isPlayRateLimitEnabled } from '../../utils/playRateLimit';

export class GameSettings {
    constructor(
        _allPanorama = false,
        _timeLimitation = 0,
        _mode = GAME_MODE.CLASSIC,
        _timeAttack = false,
        _zoomControl = true,
        _moveControl = true,
        _panControl = true,
        _countdown = 0,
        _scoreMode = SCORE_MODE.NORMAL,
        _areaParams = null,
        _optimiseStreetView = true,
        _nbRound = 5
    ) {
        this.allPanorama = _allPanorama;
        this.time = _timeLimitation;
        this.modeSelected = _mode;
        this.timeAttackSelected = _timeAttack;
        this.zoomControl = _zoomControl;
        this.moveControl = _moveControl;
        this.panControl = _panControl;
        this.countdown = _countdown;
        this.scoreMode = _scoreMode;
        this.areaParams = _areaParams;
        this.optimiseStreetView = _optimiseStreetView;
        this.nbRoundSelected = _nbRound;
    }
}

export default {
    namespaced: true,
    state: () => ({
        gameSettings: new GameSettings(),
        difficulty: 2000,
        bboxObj: null,
        name:
            localStorage.getItem('playerName')?.slice(0, 20) ||
            i18n.t('CardRoomPlayerName.anonymousPlayerName'),
        invalidName: false,
    }),
    mutations: {
        [MutationTypes.SETTINGS_SET_GAME_SETTINGS](state, settings) {
            state.gameSettings = { ...state.gameSettings, ...(settings || {}) };
        },
        [MutationTypes.SETTINGS_SET_DIFFICULTY](state, difficulty) {
            state.difficulty = Number(difficulty) || 2000;
        },
        [MutationTypes.SETTINGS_SET_BBOX](state, bboxObj) {
            state.bboxObj = bboxObj || null;
        },
        [MutationTypes.SETTINGS_SET_PLAYER_NAME](state, playerName) {
            state.name = (playerName || '').slice(0, 20);
        },
        [MutationTypes.SETTINGS_RESET](state) {
            state.gameSettings = new GameSettings();
            state.difficulty = 2000;
            state.bboxObj = null;
            state.invalidName = false;
        },
    },
    actions: {
        setPlayerName({ commit }, playerName) {
            const v = (playerName || '').slice(0, 20);
            localStorage.setItem('playerName', v);
            commit(MutationTypes.SETTINGS_SET_PLAYER_NAME, v);
        },
        async setSettings({ commit, state, rootState, dispatch }) {
            const access = router.currentRoute?.query?.access || null;
            if (isPlayRateLimitEnabled()) {
                const quota = await consumePlayQuota({ access });
                if (quota && quota.status === 429) {
                    const tier = quota?.data?.tier || (access ? 'vip' : 'base');
                    dispatch('rate_limitStore/show', { tier }, { root: true });
                    return;
                }
            }

            let difficulty = 2000;
            let bboxObj = null;

            if (rootState.homeStore?.map?.geojson) {
                bboxObj = bbox(rootState.homeStore.map.geojson);
                commit(MutationTypes.SETTINGS_SET_BBOX, bboxObj);
                difficulty = getMaxDistanceBbox(bboxObj) / 10;
            }
            commit(MutationTypes.SETTINGS_SET_DIFFICULTY, difficulty);

            const query = {
                ...(access ? { access } : {}),
                ...(isPlayRateLimitEnabled() ? { rl: '1' } : undefined),
            };

            router.push({
                name: 'street-view',
                query,
                params: {
                    ...state.gameSettings,
                    playerName: state.name,
                    difficulty,
                    placeGeoJson: rootState.homeStore?.map?.geojson || null,
                    bboxObj,
                    ...(rootState.homeStore?.map
                        ? { mapDetails: rootState.homeStore.map.details }
                        : undefined),
                },
            });
        },
    },
};
